import { useDeclineReasons } from "../../../hooks/community/useDeclineReasons";
import { CommunityAdminReasonModel } from "../models/CommunityAdminReasonModel"

type Props = {
    reason: CommunityAdminReasonModel;
    setReason: (reason: CommunityAdminReasonModel) => void;
}

export const CommunityAdminReason = ({ reason, setReason }: Props) => {
    const { list: declineReasons } = useDeclineReasons();
    return (
        <div className="admin-community-action-modal-content__reason">
            <div>
                <span className="title-section">
                    CANCEL REASON
                </span>
                <select 
                    value={reason.reason_id}
                    onChange={(e) => setReason({...reason, reason_id: Number(e.target.value)})}
                >
                    { declineReasons.map((r, i) => (
                        <option key={i} value={r.id}>{r.title}</option>
                    ))}
                </select>
            </div>

            <div>
                <span className="title-section">
                    Note
                </span>
                <input 
                    value={reason.note ?? ''} 
                    type="text" 
                    maxLength={100}
                    onChange={(e) => setReason({...reason, note: e.target.value})}
                />
                <div className="meta-section">
                    <span>{reason.note.length}/100</span>
                </div>
            </div>
        </div>
    )
}